import { createFileRoute } from "@tanstack/react-router";
import { QuestionsPage } from "@/routes/_main/exams/$slug/questions";

export const Route = createFileRoute("/_main/groups/$gid/exams/$slug/questions")({
  component: QuestionsPage,
});
